import { Component, Input } from '@angular/core';
import { BaseFormControlComponent } from '../../../../shared/components/form-inputs/base-form-control.component';

@Component({
  selector: 'boi-form-textarea',
  templateUrl: './form-textarea.component.html',
  styleUrls: ['./form-textarea.component.scss']
})
export class FormTextAreaComponent extends BaseFormControlComponent {
  @Input() public fieldMaxLength?: number;

  constructor() {
    super();
  }
}
